<template>
  <div class="home">
    <Header></Header>
    <div class="banner">
      <div class="banner-content">
        <div class="left-banner">
          <div class="title">雾计算</div>
          <div class="content">基于容器技术的开放计算资源平台，支持智能调度、镜像管理、实例部署、实时监控等功能，能够快速部署服务，轻松运维。</div>
        </div>
        <div class="right-banner">
          <img class="" src="./../assets/compute/banner.png" alt="沐桦科技" />
        </div>
      </div>
    </div>
    <div class="feature">
      <div class="muhua-title">产品特色</div>
      <div class="feature-wrap">
        <div class="feature-card">
          <div class="left-content">
            <div class="feature-title">超多节点、广泛分布</div> 
            <div class="feature-content">雾计算拥有数十万的服务节点，分布在全球各地，可以构建强大的分布式服务。</div>
          </div>
          <div class="right-content">
            <img src="./../assets/compute/node.png"  alt="" class="border">
          </div>
        </div>
         <div class="feature-card">
          <div class="right-content">
            <img src="./../assets/compute/online.png"  alt="" class="border">
          </div>
           <div class="left-content">
            <div class="feature-title">靠近设备、稳定在线</div> 
            <div class="feature-content">雾计算的节点均部署在以家用带宽为主的场景中，贴近用户，响应延时低，通过增加节点密度同时降低单节点覆盖范围，带来更强大的雾计算体验。</div>
          </div>
        </div>
         <div class="feature-card">
          <div class="left-content">
            <div class="feature-title">海量带宽及存储资源</div> 
            <div class="feature-content">汇聚海量节点，为服务海量用户的视频和存储产品提供了资源基础。</div>
          </div>
          <div class="right-content">
            <img src="./../assets/compute/sources.png"  alt="" class="border">
          </div>
        </div>
      </div>
    </div>
    <section class="advantage-wrap">
      <div class="muhua-title advantage-title">简单易用、高效可靠</div>
      <div class="card-content">
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/compute/docker.png" alt="">
            <div class="card-title ">Docker部署</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/compute/env.png" alt="">
            <div class="card-title ">环境统一</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/compute/dynamic.png" alt="">
            <div class="card-title ">动态扩容</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img src="./../assets/compute/scheduling.png" alt="">
            <div class="card-title ">跨区调度</div>
          </div>
        </div>
      </div>
    </section>
    <section class="use-env">
      <div class="muhua-title ">应用场景</div>
      <div class="card-content">
        <div class="card-wrap">
          <div class="card">
            <img class="border" src="./../assets/compute/dv.png" alt="沐桦科技" />
            <div class="help-title">视频分发</div>
            <div class="help-content">为终端用户提供高清流畅的视频体验，对带宽成本降低有较高需求的应用场景</div>
            <div class="tag">视频、直播、点播…</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img class="border" src="./../assets/compute/cache.png" alt="沐桦科技" />
            <div class="help-title">资源存储</div>
            <div class="help-content">数据产生量大，对数据安全性要求高，且需要大体量存储空间和带宽流量的应用场景。</div>
            <div class="tag">网盘、文件备份…</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img class="border" src="./../assets/compute/stress.png" alt="沐桦科技" />
            <div class="help-title">拨测/压测</div>
            <div class="help-content">高性价比的资源和技术，可帮助用户有效的降低成本。</div>
            <div class="tag">视频平台、咨询站、APP…</div>
          </div>
        </div>
      </div>
    </section>
    <section class="product-detail">
      <div class="muhua-title advantage-title">了解如何使用沐桦雾计算服务</div>
      <div class="detail-wrap">
        <router-link to="/useDoc" class="button compute">查看产品文档</router-link>
      </div>
    </section>
    <Footer>
     
    </Footer>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { mapState, mapActions, mapMutations } from "vuex";
  import Footer from "@/components/Footer.vue";
  import Menu from "@/components/Menu.vue";
  import Header from "@/components/Header.vue";

  export default {
    name: "home",
    components: {
      Footer,
      Menu,
      Header
    },
    data () {
      return {
        activeIndex: '2-1'
      };
    },
    computed: mapState({}),
    created() { },
    methods: {
      ...mapActions([""])
    }
  };
</script>

<style scoped lang="stylus">

  .feature{
    background:rgba(248,252,255,1);
    .feature-wrap{
      margin: 0 auto;
      width: 50%;
      max-width: 980px;
      .feature-card {
        display: flex;
        padding-bottom: 96px;
        .left-content{
          width: 50%;
          .feature-title{
            width:216px;
            height:34px;
            font-size:24px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(63,80,124,1);
            line-height:34px;
            margin: 68px 0 26px;
          }

          .feature-content{
            font-size:13px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(116,133,152,1);
            line-height:22px;
          }
        }
        .right-content{
          width: 50%;  
          text-align: center;
          img{
            width: 240px;
            height: 240px;
          }        
        }
      }

    }
  }

  .right-header {
    position: absolute;
    right: 0;
    top: 0;
    line-height: 60px;
    display: flex;

    .menu {
      line-height: 60px;

      a {
        margin-right: 40px;
      }
    }

    .user-button {
      width: 94px;
      height: 30px;
      background: #00AEEF;
      border-radius: 4px;
      margin: 15px auto;
      line-height: 30px;

      a {
        color: #FFFFFF;
        font-weight: 400;
        line-height: 20px;
        width: 49%;
        display: inline-block;
        text-align: center;
      }

      a.login {
        border-right: 1px solid #fff;
      }
    }

    .user-button:hover {
      background: #008BBF;
    }
  }

  .banner {
    background: #282A3C;
    width: 100%;
    height: 400px;
    display: flex;

    .banner-content {
      width: 80%;
      margin: 0 auto;
      display: flex;
      max-width: 1200px;
    }
  }

  .left-banner {
    width: 59%;
    .title {
      margin: 121px 0 19px 0;
      font-size:38px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:64px;
    }

    .content {
      width: 383px;
      height: 90px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 23px;
      margin-bottom: 27px;

      font-size:18px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:32px;
    }

    .know-more {
      width: 96px;
      height: 31px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      font-size: 11px;
      font-weight: 400;
      color: rgba(40, 42, 60, 1);
      line-height: 20px;
      text-align: center;
      line-height: 31px;
    }
  }

  .right-banner {
    width: 41%;

    img {
      height: 400px;
    }
  }

  .compute-wrap {
    width: 100%;
    background: #FFFFFF;

    .compute-title {
      font-size: 20px;
      font-weight: 400;
      color: rgba(63, 80, 124, 1);
      line-height: 23px;
      margin: 34px auto;
      text-align: center;
    }

    .card-wrap {
      width: 25%;
      margin-bottom: 68px;

      .card {
        width: 158px;
        // height:191px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(63, 79, 124, 0.3);
        margin: 0 auto;
        text-align: center;

        img {
          width: 79px;
          height: 65px;
          margin: 31px 0 14px;
        }

        .title {
          font-size: 11px;
          font-weight: 400;
          color: rgba(63, 79, 124, 1);
          line-height: 20px;
          margin-bottom: 14px;
        }

        a {
          display: inline-block;
          width: 93px;
          height: 27px;
          border-radius: 2px;
          border: 1px solid rgba(0, 174, 239, 1);
          font-size: 9px;
          font-weight: 400;
          color: rgba(0, 174, 239, 1);
          line-height: 27px;
          margin-bottom: 20px;
        }
      }

    }

    .compute-content {
      display: flex;
      width: 80%;
      margin: 0 auto;
      max-width: 1200px;
    }
  }

  .advantage-wrap {
    background: #fff;

    .card-content {
      display: flex;
      width: 80%;
      margin: 0 auto;
      max-width: 1200px;

      .card-wrap {
        width: 25%;

        .card {
          margin: 0 auto;
          text-align: center;
        }

        img {
          width: 70px;
          height: 70px;
          background: rgba(255, 255, 255, 1);
          margin-botton: 14px;
        }

        .card-title {
          font-size: 16px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(63, 79, 124, 1);
          line-height: 20px;
          margin: 19px 0 96px;
        }
      }
    }

  }

  .use-env{
    background:rgba(248,252,255,1);
    .card-content{
      display: flex;
      width: 80%;
      margin: 0 auto;
      max-width: 1200px;
      .card-wrap {
        width: 33%;
        .card{
          margin: 0 auto;
          text-align: center;
          img {
            width: 66px;
            height: 66px;     
            margin-bottom: 19px;     
          }
          .help-title {
            font-size:16px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(63,79,124,1);
            line-height:20px;
          }
          .help-content {
            font-size:9px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(116,133,152,1);
            line-height:16px;
            max-width: 185px;
            font-size:13px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(116,133,152,1);
            line-height:22px
            margin: 9px auto 0px;
            min-height: 100px;
          }
          .button{
            width: 93px;
            height: 27px;
            background:rgba(0,174,239,1);
            border-radius:2px;
            border:1px solid rgba(0,174,239,1);
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:12px;
          }
          .tag{
            font-size: 10px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #748598;
            line-height: 16px;
            padding: 4px 5px;
            height: 16px;
            margin: 9px auto 96px;
            background: #e6eff8;
            border-radius: 2px;
            display: inline-block;
          }
        } 
      }
    }
  }

  .product-detail {
    background-image: url('../assets/background/white_point.png');
    .detail-wrap {
      display: flex;
      justify-content: center;
    }
    .button {
      margin: 0 auto 39px;
    }
  }
</style>
